import onResize from '../utils/onResize'
import { get } from '@bigyouth/base'
import withResponsive from '../hoc/withResponsive'

export default withResponsive({
  name: 'toggle-content',

  ui: {
    button: '[js-toggle-content-button]',
    close: '[js-toggle-content-close]',
    content: '[js-toggle-content-content]',
    innerContent: '[js-toggle-content-inner]',
  },

  events: [
    {
      target: 'button',
      on: 'click',
      handle ({ target }) {
        this.openPanel()

        if (this.ui.content.getAttribute('js-sr-inactive') !== null) {
          this.ui.content.removeAttribute('js-sr-inactive')
        } else {
          this.ui.content.setAttribute('js-sr-inactive', '')
        }
      },
    },
  ],

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    if (this.ui.content.classList.contains('is-visible')) {
      const height = this.ui.innerContent.offsetHeight
      this.ui.content.style.height = `${height}px`
    }
  },

  openPanel () {
    // if connected accordions
    if (this.props && this.props.connected) {
      const activePanel = get(
        '[js-toggle-content-content].is-visible',
        this.el.parentNode,
      )
      const activeButton = get(
        '[js-toggle-content-button].is-active',
        this.el.parentNode,
      )

      if (activePanel && activePanel !== this.ui.content) {
        this.closePanel(activePanel, activeButton)
      }
    }

    this.ui.button.classList.toggle('is-active')
    this.ui.content.classList.toggle('is-visible')

    if (this.ui.content.classList.contains('is-visible')) {
      const height = this.ui.innerContent.offsetHeight
      this.ui.content.style.height = `${height}px`

      setTimeout(() => {
        this.ui.content.classList.add('has-overflow')
      }, 300)
    } else {
      this.ui.content.style.height = 0
      this.ui.content.classList.remove('has-overflow')

      if (this.props && this.props.scrollUp) {
        this.scrollUp()
      }
    }
  },

  closePanel (panel, button) {
    panel.style.height = '0px'
    panel.classList.remove('is-visible')
    panel.classList.remove('has-overflow')
    button.classList.remove('is-active')
  },

  scrollUp () {
    window.scrollBy({
      top: -this.ui.content.offsetHeight,
      left: 0,
      behavior: 'smooth',
    })
  },

  scrollUpConnected () {
    const offset = this.el.parentNode.offsetTop + this.el.offsetTop

    if (window.scrollY > offset) {
      window.scrollTo({
        top: offset,
        left: 0,
        behavior: 'smooth',
      })
    }
  },
})
